module.exports = __webpack_public_path__ + "img/instruction-icon.586e7ab8.svg";